const handleFetchUserSessionHistoryFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.userSessionHistory = action.payload.data;
    state.currentPage = action.payload.current_page;
    state.perPage = action.payload.limit;
    state.totalPages = action.payload.total_pages;
    state.total = action.payload.total_count;
    state.lastUpdated = action.payload.last_updated;
    state.message = action.payload.message;
};

export {
    handleFetchUserSessionHistoryFulfilled
};
